import { Injectable, inject } from '@angular/core';
import { environment } from '@environments/environment';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
export const idleNone = () => { };

@Injectable({
  providedIn: 'root',
})
export class IdleConfigService {
  private readonly idle = inject(Idle);
  private readonly keepalive = inject(Keepalive);

  public init(
    startClbk = idleNone,
    endClbk = idleNone,
    timeoutClbk = idleNone,
    timeoutWarningClbk = (s) => {},
    pingClbk = idleNone,
  ) {
    // set idle parameters
    this.idle.setIdle(environment.IdleKeepAlive.BeforeIdle); // how long can they be inactive before considered idle, in seconds
    this.idle.setTimeout(environment.IdleKeepAlive.Timeout); // how long can they be idle before considered timed out, in seconds
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES); // provide sources that will 'interrupt' aka provide events indicating the user is active

    // do something when the user becomes idle
    this.idle.onIdleStart.subscribe(startClbk);

    // do something when the user is no longer idle
    this.idle.onIdleEnd.subscribe(endClbk);

    // do something when the user has timed out
    this.idle.onTimeout.subscribe(timeoutClbk);

    // do something as the timeout countdown does its thing
    this.idle.onTimeoutWarning.subscribe(timeoutWarningClbk);

    // set keepalive parameters, omit if not using keepalive
    this.keepalive.interval(environment.IdleKeepAlive.Ping); // will ping at this interval while not idle, in seconds
    this.keepalive.onPing.subscribe(pingClbk); // do something when it pings

    this.idle.watch();
  }
}
